export const PO_STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600" },
  submitted: { label: "Submitted", cls: "bg-blue-100 text-blue-700" },
  needs_review: { label: "Needs review", cls: "bg-amber-100 text-amber-800" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-700" },
  location_planning: { label: "Location planning", cls: "bg-violet-100 text-violet-700" },
  ready_to_receive: { label: "Ready to receive", cls: "bg-teal-100 text-teal-700" },
  receiving: { label: "Receiving", cls: "bg-orange-100 text-orange-700" },
  discrepancy_review: { label: "Discrepancy review", cls: "bg-red-100 text-red-700" },
  completed: { label: "Completed", cls: "bg-emerald-600 text-white" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-500" },
};

export const PO_STATUS_LABEL = (s) => PO_STATUS_META[s]?.label || s;

export const CONDITIONS = [
  { v: "good", l: "Good", hint: "Sellable stock", cls: "bg-emerald-500", text: "text-emerald-300", chip: "bg-emerald-100 text-emerald-700" },
  { v: "damaged", l: "Damaged", hint: "Held, not sellable", cls: "bg-red-500", text: "text-red-300", chip: "bg-red-100 text-red-700" },
  { v: "quarantine", l: "Quarantine", hint: "Held for inspection", cls: "bg-amber-500", text: "text-amber-300", chip: "bg-amber-100 text-amber-800" },
];
export const CONDITION_META = Object.fromEntries(CONDITIONS.map((c) => [c.v, c]));

export const formatDuration = (secs) => {
  if (secs == null || Number.isNaN(secs)) return "—";
  const s = Math.max(0, Math.round(secs));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m ${sec}s`;
  return `${sec}s`;
};

export const CANONICAL_FIELDS = [
  { key: "sku", label: "SKU", required: true },
  { key: "barcode", label: "Barcode / UPC", required: true },
  { key: "expected_qty", label: "Expected quantity", required: true },
  { key: "product_title", label: "Product title", required: false },
  { key: "variant_title", label: "Variant", required: false },
  { key: "vendor", label: "Vendor", required: false },
  { key: "customer_location", label: "Proposed location", required: false },
];
